import { AbiItem } from 'web3-utils';

export const LSP3AccountABI: AbiItem[] = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_newOwner',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'contractAddress',
        type: 'address',
      },
    ],
    name: 'ContractCreated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'key',
        type: 'bytes32',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'value',
        type: 'bytes',
      },
    ],
    name: 'DataChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: '_operation',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: '_to',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_value',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'Executed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'typeId',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'returnedValue',
        type: 'bytes32',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'receivedData',
        type: 'bytes',
      },
    ],
    name: 'UniversalReceiver',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'ValueReceived',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'dataKeys',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_operation',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '_to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_value',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'execute',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_key',
        type: 'bytes32',
      },
    ],
    name: 'getData',
    outputs: [
      {
        internalType: 'bytes',
        name: '_value',
        type: 'bytes',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_hash',
        type: 'bytes32',
      },
      {
        internalType: 'bytes',
        name: '_signature',
        type: 'bytes',
      },
    ],
    name: 'isValidSignature',
    outputs: [
      {
        internalType: 'bytes4',
        name: 'magicValue',
        type: 'bytes4',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4',
      },
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'dataCount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'allDataKeys',
    outputs: [
      {
        internalType: 'bytes32[]',
        name: '',
        type: 'bytes32[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32[]',
        name: '_keys',
        type: 'bytes32[]',
      },
      {
        internalType: 'bytes[]',
        name: '_values',
        type: 'bytes[]',
      },
    ],
    name: 'setDataMultiple',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32[]',
        name: '_keys',
        type: 'bytes32[]',
      },
    ],
    name: 'getDataMultiple',
    outputs: [
      {
        internalType: 'bytes[]',
        name: '',
        type: 'bytes[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_key',
        type: 'bytes32',
      },
      {
        internalType: 'bytes',
        name: '_value',
        type: 'bytes',
      },
    ],
    name: 'setData',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_typeId',
        type: 'bytes32',
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'universalReceiver',
    outputs: [
      {
        internalType: 'bytes32',
        name: 'returnValue',
        type: 'bytes32',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

export const LSP3Account_bytecode =
  '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';
